import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Autocomplete from '@material-ui/lab/Autocomplete';

import PropTypes from 'prop-types';

import styles from './styles';

export const Multiselect = props => {
  const {
    classes: classesProp,
    className,
    options,
    onChange,
    ChipProps,
    renderTags: renderTagsProp,
    maxRowsBeforeScroll,
    error = false,
    loading = false,
    borderSelectColor = 'primary',
    inputVariant = 'outlined',
    inputLabel = '',
    inputPlaceholder = 'Placeholder text',
    helperText,
    TextFieldProps,
    ...other
  } = props;

  const {
    formHelperMessage: formHelperMessageStyle,
    notchedOutline,
    renderTags: renderTagsStyle,
    ...classes
  } = classesProp;

  const ErrorMessage = () => (
    <>
      <ErrorOutlineIcon />
      <span>{helperText}</span>
    </>
  );

  const renderTags = (...params) => {
    return maxRowsBeforeScroll && renderTagsProp ? (
      <div className={renderTagsStyle}>{renderTagsProp(...params)}</div>
    ) : (
      renderTagsProp && renderTagsProp(...params)
    );
  };

  const renderInput = params => (
    <TextField
      {...params}
      color={borderSelectColor}
      error={error}
      variant={inputVariant}
      label={inputLabel}
      placeholder={inputPlaceholder}
      helperText={error && helperText ? <ErrorMessage /> : helperText}
      FormHelperTextProps={{ classes: { contained: formHelperMessageStyle } }}
      InputProps={{
        ...params.InputProps,
        classes: { notchedOutline }
      }}
    />
  );

  return (
    <Autocomplete
      multiple
      fullWidth
      classes={classes}
      className={className}
      options={options}
      renderTags={renderTags}
      loading={loading}
      filterSelectedOptions
      disableCloseOnSelect
      onChange={onChange}
      renderInput={renderInput}
      closeIcon={<CancelOutlinedIcon />}
      {...other}
    />
  );
};

Multiselect.defaultProps = {
  inputVariant: 'outlined',
  inputLabel: '',
  borderSelectColor: 'primary',
  inputPlaceholder: 'Placeholder text'
};

Multiselect.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  /** Array of options to choose from  */
  options: PropTypes.array,
  /** Function to fire on editing selection  */
  onChange: PropTypes.func,
  /** Props to pass into default Chip component  */
  ChipProps: PropTypes.object,
  /**
  * 	Render the selected value(s). 
  Signature:
  function(value: T[], getTagProps: function) => ReactNode
  value: The value provided to the component. Will be an array for multiselect
  getTagProps: A tag props getter.
  */
  renderTags: PropTypes.func,
  /** Maximum rows shown in select before scrolling. Assumes 32px Chip height + 8px padding */
  maxRowsBeforeScroll: PropTypes.number,
  /** Boolean determining if select is in an error state */
  error: PropTypes.bool,
  /** Boolean determining if the select is in a loading state */
  loading: PropTypes.bool,
  /** Color on outer border when selected */
  borderSelectColor: PropTypes.oneOf(['primary', 'secondary']),
  /** The variant to use for TextField input. Input fields will be overridden
   * if you use the renderInput prop from Autocomplete API.
   */
  inputVariant: PropTypes.string,
  /** Label for field */
  inputLabel: PropTypes.string,
  /** Placeholder text before typing */
  inputPlaceholder: PropTypes.string,
  /** Text or node to show up below the input */
  helperText: PropTypes.node,
  /** Additional props to pass into the TextField component */
  TextFieldProps: PropTypes.object
};

export default withStyles(styles)(Multiselect);
